<template>
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">Edit Location Link</h5>
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
    </div>
    <div class="modal-body">
      <form class="form-horizontal needs-validation" novalidate id="form_edit_llk">
        <div class="mb-3">
          <label class="col-md-12">Shelf code</label>
          <div class="col-md-12">
            <input type="text" class="form-control form-control-fix" placeholder="shelf code" v-model="shelf_code" disabled />
            <div class="invalid-feedback">Please enter shelf code.</div>
          </div>
        </div>
        <div class="mb-3">
          <label class="col-md-12">Part store</label>
          <div class="col-md-12">
            <select v-model="ps_id" class="form-select" id="select_ps_id" style="width: 100%;">
              <option value="0">-- not select part store --</option>
              <option v-for="(row, i) in ps_list" :key="'ps_id_' + i" :value="row.ps_id">
                {{ 'Dock: ' + row.dk_code + ' | Part: ' + row.pr_number + ' | Supplier: ' + row.spl_code }}
              </option>
            </select>
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary btn-fix" data-bs-dismiss="modal" id="cls_btn"><i class="fa fa-times"></i> Close</button>
      <button type="button" class="btn btn-info btn-fix" id="act_btn" @click="editLocationlink"><i class="fas fa-save"></i> Save</button>
    </div>
  </div>
</template>

<script>
import api from '../../models/locationlink'

export default {
  props: ['search', 'data'],
  data() {
    return {
      llk_id: 0,
      shelf_code: '',
      ps_id: 0,
      dk_code: '',
      pr_number: '',
      pr_name: '',
      spl_code: '',
      ps_list: []
    }
  },
  created() {
    this.llk_id = this.data.llk_id
    this.shelf_code = this.data.shelf_code
    this.ps_id = this.data.ps_id
    this.dk_code = this.data.dk_code
    this.pr_number = this.data.pr_number
    this.pr_name = this.data.pr_name
    this.spl_code = this.data.spl_code
    this.getPartStore()
  },
  mounted() {
    $('#select_ps_id').select2({
      placeholder: 'Select part store',
      allowClear: true,
      dropdownParent: $('#llk_modal'),
      dropdownPosition: 'below'
    })
  },
  watch: {
    data: function(val, old_val) {
      this.llk_id = val.llk_id
      this.shelf_code = val.shelf_code
      this.ps_id = val.ps_id
      this.dk_code = val.dk_code
      this.pr_number = val.pr_number
      this.pr_name = val.pr_name
      this.spl_code = val.spl_code
      this.getPartStore()
    }
  },
  methods: {
    getPartStore() {
      this.ps_list = []
      api.getPartStore(
        this.$store.state.URLHost,
        this.header,
        result => {
          if (result.response === true) {
            if (this.ps_id !== 0) {
              this.ps_list.push({
                ps_id: this.ps_id,
                dk_code: this.dk_code,
                pr_number: this.pr_number,
                pr_name: this.pr_name,
                spl_code: this.spl_code
              })
            }
            if (result.data.part_store) {
              this.ps_list.push(...result.data.part_store)
            }
          } else {
            this.alert_msg('warning', 'An error occurred.', result.message)
          }
        },
        error => {
          this.alert_msg('error', 'An error occurred.', error.message)
        }
      )
    },
    editLocationlink() {
      $('#act_btn').prop('disabled', true)
      let form_data = {
        ps_id: $('#select_ps_id').val() ? $('#select_ps_id').val() : 0
      }
      api.editLocationlink(
        this.$store.state.URLHost,
        this.llk_id,
        form_data,
        this.header,
        result => {
          if (result.response === true) {
            this.alert_msg('success', 'Successful.', result.message)
          } else {
            this.alert_msg('error', 'An error occurred.', result.message)
          }
          this.search()
          $('#act_btn').prop('disabled', false)
          $('#llk_modal').modal('hide')
        },
        error => {
          this.alert_msg('error', 'An error occurred.', error.message)
          this.search()
          $('#act_btn').prop('disabled', false)
          $('#llk_modal').modal('hide')
        }
      )
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/modal/llk_edit_modal.vue